// src/components/cart/ReservationCard.js
import React from "react";
import { useNavigate } from "react-router-dom";

const ReservationCard = ({ id, date, type, gender, description }) => {
  const navigate = useNavigate();

  const handleDetailsClick = (e) => {
    e.preventDefault();
    navigate(`/ApplyReservation/${id}`);
  };

  return (
    <div className="job-detail">
      <div className="job-top">
        <div className="top-detail">
          <div className="job-date">
            <p>{date}</p>
          </div>
        </div>

        <div className="job-tital">
          <p className="tital">{type}</p>
          {description && (
            <p style={{
              fontSize: "16px",
              color: "#000",
              marginTop: "8px",
              lineHeight: "1.4"
            }}>
              {description}
            </p>
          )}
        </div>
      </div>

      <div className="job-buttom">
        <div className="buttom-text">
          <div className="context">
            <h1>Gender</h1>
            <p>{gender}</p>
          </div>
          <a href="#" className="rounded-btn" onClick={handleDetailsClick}>
            Details
          </a>
        </div>
      </div>
    </div>
  );
};

export default ReservationCard;